import React from 'react';
import moment from 'moment';

const WeekdayMobile: React.FC = () => {
  const weekArray = moment.weekdaysShort();

  return (
    <ul className="smls-calendar-weekday-mobile">
      {weekArray.map((weekday: string) => {
        return <li key={weekday}>{weekday}</li>;
      })}
    </ul>
  );
};

export default WeekdayMobile;
